<mat-form-field floatLabel="never" [ngClass]="classField()">
  <mat-select placeholder="..." [formControl]="control()">
    <mat-option [value]="'Apartment'"><span translate>Apartment</span></mat-option>
    <mat-option [value]="'Business'"><span translate>Business</span></mat-option>
    <mat-option [value]="'Cafe'"><span translate>Cafe</span></mat-option>
    @if (!unit()) {
      <mat-option [value]="'Combination'"><span translate>Combination</span></mat-option>
    }
    @if (!unit()) {
      <mat-option [value]="'Garage'"><span translate>Garage</span></mat-option>
    }
    <mat-option [value]="'Hotel'"><span translate>Hotel</span></mat-option>
    <mat-option [value]="'House'"><span translate>House</span></mat-option>
    <mat-option [value]="'Office'"><span translate>Office</span></mat-option>
    <mat-option [value]="'Other'"><span translate>Other</span></mat-option>
    @if (!unit()) {
      <mat-option [value]="'Parking'"><span translate>Parking</span></mat-option>
    }
    <mat-option [value]="'PracticeSpace'"><span translate>Practice space</span></mat-option>
    <mat-option [value]="'Recreation'"><span translate>Recreation</span></mat-option>
    <mat-option [value]="'Restaurant'"><span translate>Restaurant</span></mat-option>
    <mat-option [value]="'Store'"><span translate>Store</span></mat-option>
    <mat-option [value]="'Studio'"><span translate>Studio</span></mat-option>
  </mat-select>
</mat-form-field>